import { Fixture } from '@cds/betting-offer';
import {
    EnhancedFixtureViewGroupingConfiguration,
    EventModel,
    EventOption,
    EventOptionGroup,
    EventParticipantImage,
} from '@frontend/sports/betting-offer/feature/model';
import { NumberDictionary, StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { NativePrice } from '@frontend/sports/odds/feature/native-price';
import { TrackData } from '@frontend/sports/tracking/feature';
import { TopEventMarketFixtureSource, TopEventsMarketParameters } from '@frontend/sports/types/components/top-events';
import { ContentLink } from '@frontend/vanilla/core';

// mirror TopEventPodTypes
export enum PodType {
    BetBuilder = 'BetBuilder',
    Grid = 'Grid',
    Outright = 'Outright',
    Single = 'Single',
    PropsMultiPod = 'PropsMultiPod',
    HandpickedOptionsPod = 'HandpickedOptionsPod',
}

export interface EventDataForOptionPanel {
    eventModel: EventModel;
    preparedOptionGoups: EventOptionGroup[];
}

export interface HandpickedOptionsModel {
    eventModel: EventModel;
    optionGroup: EventOptionGroup;
    option: EventOption;
    //TODO try to replace native price with Odds
    previousOdds?: NativePrice;
}

export interface TopEventsModuleData {
    title?: string;
    podData: TopEventsPodData[];
    href?: string;
}

export interface LinkConfig {
    link?: string;
    linkText?: string;
    disableLinkTextAndClick?: boolean;
}

export interface PodEventModelRequest {
    eventData: EventModel;
    sourceFixtures: StringDictionary<TopEventsSourceFixture>;
    selectionTextOverride?: { [key: string]: string };
    isDetailed?: boolean;
    allowDuplicates?: boolean;
    blackListMarketGroupIds?: string[];
    orderAsConfigured?: boolean;
    previousOdds?: NumberDictionary<NativePrice>;
}

export interface TopEventsPodData {
    podId: string;
    title?: string;
    podType: PodType;
    index: number;
    isExpanded: boolean;
    isLogoVisible: boolean;
    logoOverride: string;
    isPromotionTag: boolean;
    showAllWagersLink: boolean;
    metaData?: string;
    events: EventModel[];
    fixtures: Fixture[];
    splitFixtures?: Fixture[];
    trackingInfo: { [key: string]: string };
    marketsBeforeShowMore?: number;
    eventsBeforeShowMore?: number;
    optionsBeforeShowMore?: number;
    mobileColumns?: number;
    link?: ContentLink;
    linkDefaultText?: string;
    enableTitleLink: boolean;
    selectionTextOverride: { [key: string]: string };
    hideBetBuilderButton?: boolean;
    hideMetadataFallback: boolean;
    hidePodHeader: boolean;
    hideBottomLink?: boolean;
    isDetailed: boolean;
    updateHandler: () => void;
    detailedGroupings: EnhancedFixtureViewGroupingConfiguration[];
    sourceFixtures: StringDictionary<TopEventsSourceFixture>;
    hideMarketHeader: boolean;
    blackListMarketGroupIds?: string[];
    marketParameters?: TopEventsMarketParameters[];
    betBuilderOptionIds?: number[];
    previousOdds?: NumberDictionary<NativePrice>;
    marketFixtureSource: TopEventMarketFixtureSource;
    showBetBuilderBadgeOnHeader: boolean;
}

export interface TopEventsOutrightData {
    event: EventModel;
    optionGroup: EventOptionGroup;
    enableOptionImages: boolean;
    optionImages: NumberDictionary<EventParticipantImage>;
    trackingSource: string;
    title: string;
    eventUrl: string;
    visibleOptionsLimit: number;
    showMoreLessButtonVisible: boolean;
    expanded: boolean;
    hideMarketHeader: boolean;
    showAllWagersLink: boolean;
}

export interface TopEventsSourceFixture {
    id: string;
    optionGroupIds: Set<string>;
    optionIds: Set<number>;
}

export interface TopEventsGridLinkData {
    link: string;
    count?: number;
    title: string;
}

export interface TopEventsTrackingData {
    actionEvent?: string;
    positionEvent?: string;
    locationEvent?: string;
    eventDetails?: string;
    leagueId?: string;
    marketId?: string;
    podData?: TrackData[];
    contentPosition?: number | undefined;
}

export interface TopEventUpdate {
    podId: string;
    event: EventModel;
}

export enum TrackingEvent {
    Click = 'click',
    Collapse = 'collapse',
    Expand = 'expand',
    PodLoaded = 'load',
    WidgetLoaded = 'Top Events Loaded',
}
